import { InputLabel, MenuItem } from '@mui/material';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import { IdResidence } from 'civil-status/constants/id-residence';

export enum ID_RESIDENCE_LIST {
  Nessuno = '',
  ConMadre = '1',
  ConPadre = '2',
  AltroIndirizzo = '3',
}

interface ListResidenceBornProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  valuesMother?: AccordionGeneralityForm;
  valuesFather?: AccordionGeneralityForm;
}

const ListResidenceBornComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  valuesMother,
  valuesFather,
}: ListResidenceBornProps): React.ReactElement => {
  const residenceData: Array<ItemVM> = useMemo(() => {
    const res: Array<ItemVM> = [];
    if (valuesMother?.typeResidence === IdResidence.Italian) {
      res.push({
        id: ID_RESIDENCE_LIST.ConMadre,
        value: 'Con la madre',
      });
    }

    if (valuesFather?.typeResidence === IdResidence.Italian) {
      res.push({
        id: ID_RESIDENCE_LIST.ConPadre,
        value: 'Con il padre',
      });
    }

    res.push({
      id: ID_RESIDENCE_LIST.AltroIndirizzo,
      value: 'Altro indirizzo',
    });

    return res;
  }, [valuesMother, valuesFather]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="residence-label">
        {required ? 'Residenza *' : 'Residenza'}
      </InputLabel>
      <PmiSelect
        labelId="residence-label"
        id="residence"
        name="residence"
        value={value}
        label={required ? 'Residenza *' : 'Residenza'}
        onChange={(event) => {
          if (event.target.value === ID_RESIDENCE_LIST.Nessuno) {
            onChange({ id: ID_RESIDENCE_LIST.Nessuno, value: 'Nessuno' });
            return;
          }

          const itemSelected: ItemVM | undefined = residenceData?.find(
            (item) => item.id === event.target.value
          );
          onChange(itemSelected);
        }}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value={ID_RESIDENCE_LIST.Nessuno}>
          <em>Nessuno</em>
        </MenuItem>
        {residenceData?.map((residence: ItemVM) => (
          <MenuItem key={residence.id} value={residence.id}>
            {residence.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListResidenceBornComponent.displayName = 'List Residence Born component';

const ListResidenceBorn = memo(ListResidenceBornComponent);

export default ListResidenceBorn as typeof ListResidenceBornComponent;
